import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../components/pages/authentication/authentication/authentication.service';
import { RecurrenceRequest } from '../models/recurrence.model';

@Injectable({
	providedIn: 'root'
})
export class RecurrenceService {
	private url = environment.api + "api/erp/recurrence";

	constructor(
		private http: HttpClient,
		private authService: AuthenticationService
	) {

	}

	getBegin() {
		var company = parseInt(this.authService.getCurrentCompanyId());
		return this.http.post(this.url + "/begin/" + company, null);
	}

	saveRecurrence(newRecurrence: RecurrenceRequest) {
		return this.http.post(this.url + "/save", newRecurrence);
	}

	deleteRecurrence(toDelete: number) {
		return this.http.delete(this.url + "/delete/" + toDelete);
	}

	getRecurrenceByFactId(factId: number) {
		return this.http.get(this.url + "/getById/" + factId);
	}

	getAllRecurrenceConfigurations(companyId: any, warehouse?: string, name?: string) {
		const params: any = { erpCompany: companyId };
	  
		if (warehouse) {
		  params.warehouse = warehouse;
		}
	  
		if (name) {
		  params.name = name;
		}
	  
		return this.http.get(this.url + '/all-config', { params });
	  }
	  
	
}